import { memo, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ChartsHandler from "../../../../components/Charts/ChartsHandler.tsx";
import CustomButtonV2 from "../../../../components/CustomButtonV2/CustomButtonV2.js";
import FiltroV2 from "../../../../components/FiltroV2/FiltroV2";
import LoadingComponent from "../../../../components/LoadingComponent/LoadingComponent.tsx";
import ModalFiltroEmbarque from "../../../../components/ModalFiltroEmbarque/ModalFiltroEmbarque.tsx";
import FiltrosRedux from "../../../../contexts/Filtros";
import MultiplosFiltrosRedux from "../../../../contexts/MultiplosFiltros.js";
import { useProfile } from "../../../../contexts/ProfileContext.tsx";
import { useToast } from "../../../../contexts/ToastContext.tsx";
import MotionContainer from "../../../../core/components/MotionContainer.tsx";
import MotionSemAutorizacao from "../../../../core/components/MotionSemAutorizacao.tsx";
import Separator from "../../../../core/components/Separator.tsx";
import Layout from "../../../../core/layout/Layout.tsx";
import {
	primeiroDiaDosMesFormatado,
	ultimoDiaDosMesFormatado,
} from "../../../../core/utils/UtilityDates.ts";
import iconeImprimir from "../../../../images/iconeImprimir.png";
import { getDashboardCockpit } from "../../../../services/ModuloGerenciador/Dashboard";
import { getGrupoClientes } from "../../../../services/ModuloGerenciador/GrupoClientes";
import { getDashCockpitSearch } from "../../../../services/ModuloGerenciador/Search";
import "./CockpitDashboard.css";

const itensFiltro = [
	{
		nomeColuna: "Descrição",
		field: "descricao",
	},
	{
		nomeColuna: "Tipo Carroceria",
		field: "tipoCarroceria",
	},
	{
		nomeColuna: "Empresa",
		field: "empresa",
	},
	{
		nomeColuna: "Filial",
		field: "filial",
	},
	{
		nomeColuna: "Unidade de Embarque",
		field: "unidEmbarque",
	},
	{
		nomeColuna: "Cidade Origem",
		field: "cidadeOrigem",
	},
	{
		nomeColuna: "Estado Origem",
		field: "estadoOrigem",
	},
	{
		nomeColuna: "Cidade Destino",
		field: "cidadeDestino",
	},
	{
		nomeColuna: "Estado Destino",
		field: "estadoDestino",
	},
	{
		nomeColuna: "Pedido",
		field: "pedido",
	},
	{
		nomeColuna: "CTE",
		field: "cte",
	},
	{
		nomeColuna: "Previsão Viagem",
		field: "previsaoEmbarque",
	},
	{
		nomeColuna: "Data Viagem",
		field: "dataEmbarque",
	},
	{
		nomeColuna: "Previsão Entrega",
		field: "previsaoEntrega",
	},
	{
		nomeColuna: "Data Entrega",
		field: "dataEntrega",
	},
	{
		nomeColuna: "Data Hora Chegada Viagem",
		field: "dataHoraChegadaEmbarque",
	},
	{
		nomeColuna: "Data Hora Chegada Entrega",
		field: "dataHoraChegadaEntrega",
	},
	{
		nomeColuna: "Data Hora Entregue",
		field: "dataHoraEntregue",
	},
	{
		nomeColuna: "Data Hora Embarcado",
		field: "dataHoraEmbarcado",
	},
	{
		nomeColuna: "Aceite",
		field: "aceite",
	},
	{
		nomeColuna: "Status",
		field: "status",
	},
	{
		nomeColuna: "Placa Cavalo",
		field: "placaCavalo",
	},
	{
		nomeColuna: "Placa Carreta",
		field: "placaCarreta",
	},
	{
		nomeColuna: "Placa Segunda Carreta",
		field: "placaCarreta2",
	},
	{
		nomeColuna: "Proprietario",
		field: "proprietario",
	},
	{
		nomeColuna: "Motorista",
		field: "veiculoMotorista",
	},
	{
		nomeColuna: "ICMS",
		field: "icms",
	},
	{
		nomeColuna: "Frete Motorista",
		field: "freteMotorista",
		tipo: "number",
	},
	{
		nomeColuna: "Frete Fiscal",
		field: "freteFiscal",
		tipo: "number",
	},
	{
		nomeColuna: "Adicional Empresa",
		field: "adicionalEmpresa",
		tipo: "number",
	},
	{
		nomeColuna: "Adicional Motorista",
		field: "adicionalMotorista",
		tipo: "number",
	},
	{
		nomeColuna: "Pedagio",
		field: "pedagio",
		tipo: "number",
	},
	{
		nomeColuna: "Classificação",
		field: "classificacao",
		tipo: "number",
	},
	{
		nomeColuna: "Margem",
		field: "margem",
	},
	{
		nomeColuna: "Adiantamento",
		field: "adiantamento",
		tipo: "number",
	},
	{
		nomeColuna: "Saldo",
		field: "saldo",
		tipo: "number",
	},
	{
		nomeColuna: "Meio Pagamento",
		field: "meioPagamento",
	},
	{
		nomeColuna: "Meio Pagamento Dois",
		field: "meioPagamento2",
	},
	{
		nomeColuna: "Km",
		field: "km",
		tipo: "number",
	},
	{
		nomeColuna: "Cliente",
		field: "cliente",
	},
	{
		nomeColuna: "Embarcador",
		field: "embarcador",
	},
	{
		nomeColuna: "Destinatario",
		field: "destinatario",
	},
	{
		nomeColuna: "LOAD",
		field: "load",
	},
	{
		nomeColuna: "Mercadoria",
		field: "mercadoria",
	},
	{
		nomeColuna: "Peso",
		field: "peso",
		tipo: "number",
	},
	{
		nomeColuna: "Embalagem",
		field: "embalagem",
	},
	{
		nomeColuna: "Observação",
		field: "observacao",
	},
	{
		nomeColuna: "Frota",
		field: "frota",
	},
	{
		nomeColuna: "Cancelado",
		field: "cancelado",
	},
	{
		nomeColuna: "Motivo",
		field: "motivo",
	},
];

function CockpitDashboard() {
	const { profile, hasRegra } = useProfile();

	const { showToast } = useToast();

	const { multiplosFiltrosRedux } = useContext(MultiplosFiltrosRedux);

	const { filtrosRedux } = useContext(FiltrosRedux);

	const [values, setValues] = useState({});

	const [dadosGrafico1, setDadosGrafico1] = useState([]);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [loading, setLoading] = useState(true);

	const [openFiltroEmbarque, setOpenFiltroEmbarque] = useState(false);

	const handleCloseFiltroEmbarque = async (value) => {
		if (!profile?.token) return;
		setLoading(true);
		const valoresFiltros = localStorage.getItem("filtros");
		const objetoFiltros = JSON.parse(valoresFiltros);
		setOpenFiltroEmbarque(false);
		if (valoresFiltros !== "{}" && valoresFiltros !== null) {
			await getDashboardCockpit(
				profile?.token,
				objetoFiltros.contexto,
				objetoFiltros.embarqueInicio,
				objetoFiltros.embarqueFinal
			)
				.then((result) => {
					setDadosGrafico1(result.data.grafico);
					setDadosTabela(result.data.tabelaCockpit);
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						showToast(error.response.data, "error");
					} else if (error.response.status === 404) {
						showToast("Nenhum dado encontrado", "error");
					} else {
						showToast(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
							"error"
						);
					}
				});
		}
		setLoading(false);
	};

	const navigate = useNavigate();

	useEffect(() => {
		setValues({
			contexto: "todos",
			dataInicio: primeiroDiaDosMesFormatado,
			dataFinal: ultimoDiaDosMesFormatado,
		});
	}, []);

	const imprimir = () => {
		window.print();
	};

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("Dashboard"));
		}
	}, [profile?.token]);

	const buscarDadosDashboard2 = async () => {
		if (!profile?.token) return;
		setLoading(true);
		if (
			(Array.isArray(filtrosRedux) && filtrosRedux.length !== 0) ||
			(filtrosRedux &&
				Object.keys(filtrosRedux).length !== 0 &&
				filtrosRedux.constructor === Object)
		) {
			const pesquisaFormatada = `${filtrosRedux.item}=${filtrosRedux.pesquisa}`;
			await getDashCockpitSearch(
				profile?.token,
				pesquisaFormatada,
				filtrosRedux.contexto ? filtrosRedux.contexto : "todos",
				filtrosRedux.embarqueInicio
					? filtrosRedux.embarqueInicio
					: primeiroDiaDosMesFormatado,
				filtrosRedux.embarqueFinal
					? filtrosRedux.embarqueFinal
					: ultimoDiaDosMesFormatado,
				filtrosRedux.grupoCliente ? filtrosRedux.grupoCliente : 1
			)
				.then((result) => {
					setDadosGrafico1(result.data.grafico);
					setDadosTabela(result.data.tabelaCockpit);
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						showToast(error.response.data, "error");
					} else {
						showToast(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
							"error"
						);
					}
				});
		} else {
			await getDashCockpitSearch(
				profile?.token,
				"undefined=undefined",
				"todos",
				primeiroDiaDosMesFormatado,
				ultimoDiaDosMesFormatado,
				1
			)
				.then((result) => {
					setDadosGrafico1(result.data.grafico);
					setDadosTabela(result.data.tabelaCockpit);
					setLoading(false);
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						showToast(error.response.data, "error");
					} else {
						showToast(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
							"error"
						);
					}
				});
		}
		setLoading(false);
	};

	const [valuesPesquisa, setValuesPesquisa] = useState([]);

	const limpar = () => {
		buscarSearchReset();
	};

	const buscarSearch = async () => {
		if (!profile?.token) return;
		setLoading(true);
		let pesquisaFormatada = `${valuesPesquisa.item}=${valuesPesquisa.pesquisa}`;
		if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
			for (let filtro of multiplosFiltrosRedux) {
				pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
			}
		}
		await getDashCockpitSearch(
			profile?.token,
			pesquisaFormatada,
			valuesPesquisa.contexto,
			valuesPesquisa.embarqueInicio,
			valuesPesquisa.embarqueFinal,
			valuesPesquisa.grupoCliente
		)
			.then((result) => {
				setDadosGrafico1(result.data.grafico);
				setDadosTabela(result.data.tabelaCockpit);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					showToast(error.response.data, "error");
				} else {
					showToast(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
						"error"
					);
				}
			});
		setLoading(false);
	};

	const buscarSearchReset = async () => {
		if (!profile?.token) return;
		setLoading(true);
		const pesquisaFormatada = "undefined=undefined";
		await getDashCockpitSearch(
			profile?.token,
			pesquisaFormatada,
			valuesPesquisa.contexto,
			valuesPesquisa.embarqueInicio,
			valuesPesquisa.embarqueFinal,
			1
		)
			.then((result) => {
				setDadosGrafico1(result.data.grafico);
				setDadosTabela(result.data.tabelaCockpit);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					showToast(error.response.data, "error");
				} else {
					showToast(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
						"error"
					);
				}
			});
		setLoading(false);
	};

	const buscarGrupoClientes = async () => {
		if (!profile?.token) return;
		await getGrupoClientes(profile?.token)
			.then((result) => {
				setListaGrupos(result.data);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					showToast(error.response.data, "error");
				} else {
					showToast(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
						"error"
					);
				}
			});
		setLoading(false);
	};

	const [listaGrupos, setListaGrupos] = useState([]);

	useEffect(() => {
		if (profile?.token) {
			buscarDadosDashboard2();
			if (valuesPesquisa.contexto) {
				buscarGrupoClientes();
				buscarSearch();
			}
		}
	}, [valuesPesquisa.contexto, profile?.token]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<Layout title="Cockpit">
			<MotionContainer key="CockpitDashboard" scroll>
				<div className="content-container-scrollable">
					<div className="header-dashboard1">
						<div className="flex2">
							<div className="flex">
								<p className="indicador-principal-faturamento-v2"></p>
								<CustomButtonV2
									classCss="custom-button-cadastrar-cock"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Cadastrar Cockpit"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										navigate("/cockpit");
									}}
								/>
							</div>
							<img
								onClick={imprimir}
								className="imagens-faturamentos"
								src={iconeImprimir}
							/>
						</div>
					</div>
					{!loading && (
						<>
							<div className="containerBuscas1">
								<div className="filtro-embarque">
									<FiltroV2
										classe="div-filtrar-faturamento-v2"
										classOption="select-options"
										itensFiltro={itensFiltro}
										valuesPesquisa={valuesPesquisa}
										setValuesPesquisa={setValuesPesquisa}
										buscarSearch={buscarSearch}
										limpar={limpar}
										listaGrupos={listaGrupos}
									/>
								</div>
							</div>
							<div className="charts">
								<div>
									<div className="graficosCockpit">
										<div className="item-cock">
											<div>
												<ChartsHandler
													data={dadosGrafico1}
													type={"bar"}
													group={true}
													height="auto"
													width={570}
												/>
											</div>
										</div>
										<div className="item-cock-scroll">
											<div>
												<table border="1">
													<thead className="head-cock">
														<tr>
															<th></th>
															{dadosTabela?.cockpitList?.map((item) => (
																<th key={item.estado}>{item.estado}</th>
															))}
															<th>Total</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td>
																<strong>Cockpit</strong>
															</td>
															{dadosTabela?.cockpitList?.map((item) => (
																<td key={item.estado}>{item.cockpit}</td>
															))}
															<td>{dadosTabela?.totalCockpit}</td>
														</tr>
														<tr>
															<td>
																<strong>Realizado</strong>
															</td>
															{dadosTabela?.cockpitList?.map((item) => (
																<td key={item.estado}>{item.realizado}</td>
															))}
															<td>{dadosTabela?.totalRealizado}</td>
														</tr>
														<tr>
															<td>
																<strong>Projetado</strong>
															</td>
															{dadosTabela?.cockpitList?.map((item) => (
																<td key={item.estado}>{item.projetado}</td>
															))}
															<td>{dadosTabela?.totalProjetado}</td>
														</tr>
														<tr>
															<td>
																<strong>Falta Cockpit</strong>
															</td>
															{dadosTabela?.cockpitList?.map((item) => (
																<td key={item.estado}>{item.faltaCockpit}</td>
															))}
															<td>{dadosTabela?.totalFaltaCockpit}</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>
						</>
					)}
					{loading && <LoadingComponent />}
				</div>
			</MotionContainer>
			<Separator size="lg" />
			<ModalFiltroEmbarque
				open={openFiltroEmbarque}
				onClose={handleCloseFiltroEmbarque}
				values={values}
			/>
		</Layout>
	);
}

export default memo(CockpitDashboard);
